import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Leftmenu from "../../components/Leftmenu";
import Rightmenu from "../../components/Rightmenu";
import Pagination from "../../components/Pagination";
import { Link, useOutletContext, useNavigate } from "react-router-dom";
import moment from "moment";
import df from "../../../images/Default_pfp.jpg";

function AdminManager() {
  const { user, token } = useOutletContext();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [roleFilter, setRoleFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 0,
    to: 0,
  });

  useEffect(() => {
    if (user && user.role !== "admin") {
      navigate("/");
      return;
    }
    fetchManagers(roleFilter, currentPage, search);
  }, [user, roleFilter, currentPage]);

  const fetchManagers = (role = roleFilter, page = 1, searchVal = search) => {
    setLoading(true);
    fetch(`/api/admin/managers?page=${page}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ role: role, search: searchVal, page }),
    })
      .then((res) => res.json())
      .then((resData) => {
        setLoading(false);
        if (resData.data?.data) {
          setUsers(resData.data.data);
          setPagination({
            current_page: resData.data.current_page,
            last_page: resData.data.last_page,
            total: resData.data.total,
            from: resData.data.from,
            to: resData.data.to,
          });
        } else if (Array.isArray(resData.data)) {
          setUsers(resData.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        setLoading(false);
      });
  };

  const handleRoleChange = (targetUserId, newRole) => {
    if (targetUserId === user.id && newRole !== "admin") {
      alert("You cannot demote your own admin account.");
      return;
    }

    if (!window.confirm(`Are you sure you want to change this user's role to ${newRole}?`)) {
      return;
    }

    setUpdatingId(targetUserId);
    fetch("/api/admin/update-user-role", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id: targetUserId, role: newRole }),
    })
      .then((res) => res.json())
      .then((data) => {
        setUpdatingId(null);
        if (data.message) {
          fetchManagers(roleFilter, currentPage, search);
        } else if (data.error) {
          alert(data.error);
        }
      })
      .catch((err) => {
        console.error(err);
        setUpdatingId(null);
      });
  };

  const handleFilterChange = (newRole) => {
    setRoleFilter(newRole);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchManagers(roleFilter, 1, search);
  };

  return (
    <div>
      <Header />
      <Leftmenu />
      <div className="main-content bg-lightblue theme-dark-bg admin-main-page" style={{ minHeight: "100vh" }}>
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left w-100" style={{ maxWidth: "100%", margin: 0, paddingRight: 0 }}>
            <div className="admin-wrap-full w-100" style={{ maxWidth: "100%", margin: 0 }}>
              {/* Header Card */}
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4 rounded-xxl overflow-hidden">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex align-items-center justify-content-between rounded-3">
                  <div className="d-flex align-items-center">
                    <Link to="/admin/dashboard" className="text-white me-3">
                      <i className="feather-arrow-left font-sm"></i>
                    </Link>
                    <div>
                      <h4 className="font-xs text-white fw-600 mb-0">Admin & Role Manager</h4>
                      <span className="font-xssss text-white opacity-75">Manage platform administrators, faculty, and student permissions</span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Link to="/admin/committee-members" className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-pill text-danger">
                      <i className="feather-award me-1"></i> Committee Members
                    </Link>
                    <Link to="/admin/dashboard" className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-pill">
                      &larr; Dashboard
                    </Link>
                  </div>
                </div>
              </div>

              {/* Filter and Search Bar */}
              <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white mb-4">
                <div className="row g-2 align-items-center justify-content-between">
                  <div className="col-md-6">
                    <div className="d-flex flex-wrap gap-2">
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          roleFilter === "all" ? "btn-dark text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("all")}
                      >
                        All Users
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          roleFilter === "admin" ? "btn-danger text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("admin")}
                      >
                        Admins
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          roleFilter === "faculty" ? "btn-primary text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("faculty")}
                      >
                        Faculty
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          roleFilter === "student" ? "btn-secondary text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("student")}
                      >
                        Students
                      </button>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <form onSubmit={handleSearchSubmit} className="d-flex gap-2">
                      <input
                        type="text"
                        placeholder="Search by name or email across all users..."
                        className="form-control font-xssss border-light-md rounded-xl"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <button type="submit" className="btn bg-current text-white font-xssss fw-600 px-3 rounded-xl">
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary font-xssss fw-600 px-2 rounded-xl"
                        onClick={() => { setSearch(""); fetchManagers(roleFilter, currentPage, ""); }}
                        title="Clear search"
                      >
                        <i className="feather-refresh-cw"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* Users List Table */}
              <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white mb-4">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-danger" role="status"></div>
                    <p className="mt-3 text-grey-600 font-xsss mb-0">Loading accounts...</p>
                  </div>
                ) : users.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table align-middle table-hover mb-0 font-xssss">
                        <thead className="bg-light">
                          <tr>
                            <th className="py-3 ps-3">User</th>
                            <th className="py-3">Current Role</th>
                            <th className="py-3">Account Status</th>
                            <th className="py-3">Member Since</th>
                            <th className="py-3 pe-3 text-end" style={{ minWidth: 200 }}>
                              Change Role Assignment
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.map((target) => (
                            <tr key={target.id} className="border-bottom">
                              <td className="ps-3 py-3">
                                <div className="d-flex align-items-center">
                                  <figure className="avatar me-3 mb-0">
                                    <img
                                      src={target.personal_details?.profile_picture || df}
                                      alt="avatar"
                                      className="shadow-sm rounded-circle w40"
                                    />
                                  </figure>
                                  <div>
                                    <h6 className="font-xsss fw-700 text-grey-900 mb-0 d-flex align-items-center gap-1">
                                      {target.name}
                                      {target.id === user.id && (
                                        <span className="badge bg-light text-muted font-xsssss ms-1">You</span>
                                      )}
                                    </h6>
                                    <span className="font-xssss text-grey-500">{target.email}</span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span
                                  className={`badge font-xsssss text-uppercase px-2 py-1 rounded-pill ${
                                    target.role === "admin"
                                      ? "bg-danger text-white"
                                      : target.role === "faculty"
                                      ? "bg-primary text-white"
                                      : "bg-light text-dark border"
                                  }`}
                                >
                                  {target.role}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge font-xsssss text-uppercase px-2 py-1 rounded-pill ${
                                    target.status === "approved"
                                      ? "bg-success text-white"
                                      : target.status === "pending"
                                      ? "bg-warning text-dark"
                                      : "bg-danger text-white"
                                  }`}
                                >
                                  {target.status}
                                </span>
                              </td>
                              <td className="text-grey-500 font-xsssss">
                                {moment(target.created_at).format("MMM D, YYYY")}
                              </td>
                              <td className="pe-3 text-end">
                                <select
                                  className="form-select form-select-sm d-inline-block font-xssss"
                                  style={{ width: "150px" }}
                                  value={target.role}
                                  disabled={updatingId === target.id || (target.id === user.id && target.role === "admin")}
                                  onChange={(e) => handleRoleChange(target.id, e.target.value)}
                                >
                                  <option value="student">Student</option>
                                  <option value="faculty">Faculty</option>
                                  <option value="admin">Admin</option>
                                </select>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <Pagination
                      currentPage={pagination.current_page}
                      lastPage={pagination.last_page}
                      total={pagination.total}
                      from={pagination.from}
                      to={pagination.to}
                      onPageChange={(p) => setCurrentPage(p)}
                      itemName="users"
                    />
                  </>
                ) : (
                  <div className="text-center py-5">
                    <i className="feather-users font-xxl text-grey-400 mb-2 d-block"></i>
                    <h5 className="fw-700 font-xs text-grey-800 mb-1">No Users Found</h5>
                    <p className="text-grey-500 font-xssss mb-0">No accounts match the current filter or search criteria.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminManager;
